import {Box, VStack} from '@chakra-ui/react';
import {LogosContent} from '@/components/Navbar/LogosContent';
import {Searchbar} from '@/components/Navbar/Searchbar/Searchbar';
import {AccueilGreeting} from './AccueilGreeting';
import {AccueilBoutonDernieresCommandes} from './AccueilBoutonDernieresCommandes';
import {AccueilCartes} from './AccueilCartes';
import {AccueilImageAmbiance} from './AccueilImageAmbiance';
import {AccueilPastilleClient} from './AccueilPastilleClient';

/**
 * Bloc d'accueil du site sur tablette et téléphone (sous `lg`) :
 * logos, photo d'ambiance avec la pastille client et la salutation, recherche, cartes d'action
 * empilées et lien vers les dernières commandes.
 */
export const AccueilHeaderMobile: React.FC = () => {
  return (
    <VStack
      display={{base: 'flex', lg: 'none'}}
      width='100%'
      align='stretch'
      spacing='16px'
      p={4}
      bg='white'
      borderBottom='1px solid'
      borderColor='gray.light'
    >
      {/* À partir de md, la navbar affiche déjà le logo de la société */}
      <Box
        display={{base: 'flex', md: 'none'}}
        justifyContent='center'
      >
        <LogosContent textFF />
      </Box>
      <AccueilImageAmbiance variante='mobile'>
        <AccueilPastilleClient variante='image' />
        <AccueilGreeting variante='image' />
      </AccueilImageAmbiance>
      <Box
        bg='white'
        borderRadius='8px'
      >
        <Searchbar alwaysShowInput />
      </Box>
      <AccueilCartes variante='ligne' />
      <AccueilBoutonDernieresCommandes variante='bloc' />
    </VStack>
  );
};
